<!-- STANDARD Modal Header -->
<div class="modal-header">
  <h3 class="modal-title">{{modalTitle}}</h3>
  <div class="header-actions">
    <i class="fa" [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}" 
       style="margin-right: 10px; cursor: pointer;" (click)="toggleMinimise()"></i>
    <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
  </div>
</div>

<!-- STANDARD Modal Body -->
<div class="modal-body" [hidden]="minimise">
  <ul class="nav nav-pills" role="tablist">
    <li [class.active]="activeTab === 1">
      <a (click)="activeTab = 1" style="cursor: pointer;" class="btn-sm">
        Form Entry
      </a>
    </li>
  </ul>
  
  <div class="tab-content">
    @if (activeTab === 1) {
<div class="tab-pane active" style="padding: 15px;">
      <!-- Entity Information Table inside tab -->
      <table class="table table-bordered form-inline enityDetails custom-table">
        <tr>
          @for (item of entityList; track $index) {
<td>
            <span>{{ item.key }}</span>
          </td>
}
        </tr>
        <tr>
          @for (item of entityList; track $index) {
<td>
            <span>{{ item.value }}</span>
          </td>
}
        </tr>
      </table>
      
      <div class="form-horizontal">
        <!-- Form Loader -->
        @if (showFormLoader) {
<div class="formLoader">
          <i class="fa fa-spinner fa-spin gt-refresh"></i>
        </div>
}

        @if (!showFormLoader) {
<div>
          <!-- Main Form Table -->
          <table class="table table-bordered form-inline custom-table">
            <tbody>
              <!-- Row 0: Checkbox -->
              @if (scheduleBFormView.rows[0]) {
<tr class="formDataBlock">
                <td class="descBlock" colspan="3">
                  <span>{{scheduleBFormView.rows[0].description}}</span>
                  <span>
                    <input type="checkbox" [checked]="scheduleBFormView.rows[0].value" 
                           [(ngModel)]="scheduleBFormView.rows[0].value"/>
                  </span>
                </td>
              </tr>
}

              <!-- Row 1-3: Text inputs (LE Name, EIN, Tax Year) -->
              @if (scheduleBFormView.rows[1]) {
<tr class="formDataBlock">
                <td class="descBlock">
                  <span>{{scheduleBFormView.rows[1].description}}</span>
                  <span>
                    <input class="form-control input-md" type="text" 
                           [(ngModel)]="scheduleBFormView.rows[1].value" disabled>
                  </span>
                </td>
                @if (scheduleBFormView.rows[2]) {
<td class="descBlock">
                  <span>{{scheduleBFormView.rows[2].description}}</span>
                  <span>
                    <input class="form-control input-md" type="text" 
                           [(ngModel)]="scheduleBFormView.rows[2].value" disabled>
                  </span>
                </td>
}
                @if (scheduleBFormView.rows[3]) {
<td class="descBlock">
                  <span>{{scheduleBFormView.rows[3].description}}</span>
                  <span>
                    <input class="form-control input-md" type="text" 
                           [(ngModel)]="scheduleBFormView.rows[3].value" disabled>
                  </span>
                </td>
}
              </tr>
}

              <!-- Row 4: Description only -->
              @if (scheduleBFormView.rows[4]) {
<tr class="formDataBlock">
                <td class="descBlock" colspan="3">
                  <span>{{scheduleBFormView.rows[4].description}}</span>
                </td>
              </tr>
}
            </tbody>
          </table>

          <!-- Part I -->
          @if (partI.header.length > 0) {
<table class="table table-bordered form-inline custom-table">
            <thead>
              <tr>
                <th colspan="14">{{partI.header[0].description}}</th>
              </tr>
              <tr>
                <th>#</th>
                @for (attrName of partI.header[1].attributeList; track $index) {
<th>{{ partI.header[1].list[attrName] }}</th>
}
              </tr>
            </thead>
            <tbody>
              @for (row of partI.rows; track $index; let rowIndex = $index) {
<tr class="formDataBlock">
                <td>{{row.num}}</td>
                @for (attrName of getObjectKeys(row.list); track $index; let i = $index) {
<td class="descBlock" style="vertical-align: middle;">
                  <!-- Number inputs shown for indexes 1, 2, and > 6 (ng-hide logic from AngularJS) -->
                  @if (i === 1 || i === 2 || i > 6) {
<input class="form-control input-md" type="text" 
                         [(ngModel)]="row.list[attrName]" onlyDigits 
                         (ngModelChange)="computeCalculationRows('partI', 1, rowIndex, attrName)">
}
                  
                  <!-- Text input (column a - index 0) -->
                  @if (i === 0) {
<input class="form-control input-md" type="text" 
                         [(ngModel)]="row.list[attrName]" maxlength="4" onlyDigits 
                         [disabled]="row.isEditable === 'N'">
}
                  
                  <!-- Checkboxes for Yes/No (column e - index 4) -->
                  @if (i === 4) {
<div style="text-align: center;">
                    <span style="vertical-align: text-bottom;">Yes </span>
                    <input type="checkbox" [checked]="row.list[attrName] === true"
                           (change)="checkBoxToggle(rowIndex, attrName, 'yes', $event)"/>
                    <span style="margin-left: 4px;vertical-align: text-bottom;">No </span>
                    <input type="checkbox" [checked]="row.list[attrName] === false"
                           (change)="checkBoxToggle(rowIndex, attrName, 'no', $event)"/>
                  </div>
}
                  
                  <!-- Computed fields (columns d, f, g - indexes 3, 5, 6) -->
                  @if (i === 3 || i === 5 || i === 6) {
<input class="form-control input-md" type="text" 
                         [(ngModel)]="row.list[attrName]" onlyDigits disabled>
}
                </td>
}
              </tr>
}
            </tbody>
          </table>
}

          <!-- Part II -->
          @if (partII.header.length > 0) {
<table class="table table-bordered form-inline custom-table">
            <thead>
              <tr>
                <th colspan="14">{{partII.header[0].description}}</th>
              </tr>
              <tr>
                <th>#</th>
                @for (attrName of partII.header[1].attributeList; track $index) {
<th>{{ partII.header[1].list[attrName] }}</th>
}
              </tr>
            </thead>
            <tbody>
              @for (row of partII.rows; track $index; let rowIndex = $index; let isLast = $last) {
<tr class="formDataBlock">
                @if (!isLast) {

                  <td>{{row.num}}</td>
                  @for (attrName of getObjectKeys(row.list); track $index; let i = $index) {
<td class="descBlock">
                    <!-- Text input (column a) -->
                    @if (i === 0) {
<input class="form-control input-md" type="text" 
                           [(ngModel)]="row.list[attrName]" maxlength="4" onlyDigits 
                           [disabled]="row.isEditable === 'N'">
}
                    
                    <!-- Regular number inputs -->
                    @if (i > 0 && attrName !== 'attrib_value_j' && attrName !== 'attrib_value_k') {
<input 
                           class="form-control input-md" type="text" [(ngModel)]="row.list[attrName]" onlyDigits>
}
                    
                    <!-- Special inputs with total computation -->
                    @if (attrName === 'attrib_value_j') {
<input class="form-control input-md" type="text" 
                           [(ngModel)]="row.list[attrName]" onlyDigits 
                           (ngModelChange)="computeTotalValues('partII', 'attrib_value_j', 8, 'attrib_value_a')">
}
                    
                    @if (attrName === 'attrib_value_k') {
<input class="form-control input-md" type="text" 
                           [(ngModel)]="row.list[attrName]" onlyDigits 
                           (ngModelChange)="computeTotalValues('partII', 'attrib_value_k', 8, 'attrib_value_b')">
}
                  </td>
}
                
}
              </tr>
}
              <!-- Totals row -->
              <tr>
                <td>Totals</td>
                <td colspan="9"></td>
                <td class="descBlock">
                  <input class="form-control input-md" type="text" 
                         [(ngModel)]="partII.rows[8].list.attrib_value_a" disabled>
                </td>
                <td class="descBlock">
                  <input class="form-control input-md" type="text" 
                         [(ngModel)]="partII.rows[8].list.attrib_value_b" disabled>
                </td>
              </tr>
            </tbody>
          </table>
}

          <!-- Part III -->
          @if (partIII.header.length > 0) {
<table class="table table-bordered form-inline custom-table">
            <thead>
              <tr>
                <th colspan="14">{{partIII.header[0].description}}</th>
              </tr>
              <tr>
                <th>#</th>
                @for (attrName of partIII.header[1].attributeList; track $index) {
<th>{{ partIII.header[1].list[attrName] }}</th>
}
              </tr>
            </thead>
            <tbody>
              @for (row of partIII.rows; track $index; let rowIndex = $index; let isLast = $last) {
<tr class="formDataBlock">
                @if (!isLast) {

                  <td>{{row.num}}</td>
                  @for (attrName of getObjectKeys(row.list); track $index; let i = $index) {
<td class="descBlock">
                    <!-- Text input (column a) - disabled for Part III -->
                    @if (i === 0) {
<input class="form-control input-md" type="text" 
                           [(ngModel)]="row.list[attrName]" disabled>
}
                    
                    <!-- Regular number inputs -->
                    @if (i > 0 && attrName !== 'attrib_value_k' && attrName !== 'attrib_value_l') {
<input 
                           class="form-control input-md" type="text" [(ngModel)]="row.list[attrName]" onlyDigits>
}
                    
                    <!-- Special inputs with total computation -->
                    @if (attrName === 'attrib_value_k') {
<input class="form-control input-md" type="text" 
                           [(ngModel)]="row.list[attrName]" onlyDigits 
                           (ngModelChange)="computeTotalValues('partIII', 'attrib_value_k', 8, 'attrib_value_a')">
}
                    
                    @if (attrName === 'attrib_value_l') {
<input class="form-control input-md" type="text" 
                           [(ngModel)]="row.list[attrName]" onlyDigits 
                           (ngModelChange)="computeTotalValues('partIII', 'attrib_value_l', 8, 'attrib_value_b')">
}
                  </td>
}
                
}
              </tr>
}
              <!-- Totals row -->
              <tr>
                <td>Totals</td>
                <td colspan="10"></td>
                <td class="descBlock">
                  <input class="form-control input-md" type="text" 
                         [(ngModel)]="partIII.rows[8].list.attrib_value_a" disabled>
                </td>
                <td class="descBlock">
                  <input class="form-control input-md" type="text" 
                         [(ngModel)]="partIII.rows[8].list.attrib_value_b" disabled>
                </td>
              </tr>
            </tbody>
          </table>
}
        </div>
}
      </div>
    </div>
}
  </div>
</div>

<!-- STANDARD Footer -->
<div class="modal-footer" [hidden]="minimise">
  <button class="save-button" type="button" [disabled]="isSaveClicked" (click)="save()">
    @if (crudLoading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
}Save and Proceed
  </button>
  <button class="reset-button" type="button" (click)="reset()">Reset</button>
  <button class="cancel-button" type="button" (click)="cancel()">Cancel</button>
</div>
